//src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import Home_menu from "./components/Home_menu";
import AddProfile from "./components/AddProfile";
import Bot from "./components/Bot";



function App() {
  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/Home_menu" element={<Home_menu />} />
      <Route path="/add-profile" element={<AddProfile />} />

      <Route path="/Bot" element={<Bot />} />


    </Routes>
  );
}

export default App;